import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { MaterialModuleModule } from '../material-module.module';
import { TruncatePipe } from '../../core/pipe/truncate.pipe';

@Component({
  selector: 'app-campaign-mail-preview',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModuleModule,
    TruncatePipe
  ],
  templateUrl: './campaign-mail-preview.component.html',
  styleUrl: './campaign-mail-preview.component.scss'
})
export class CampaignMailPreviewComponent implements OnInit, AfterViewInit {
  private _route = inject(ActivatedRoute);

  @ViewChild('previewFrame') previewFrame!: ElementRef<HTMLIFrameElement>;

  // Email preview properties
  campaignName: string = '';
  recipientName: string = '';
  senderName: string = '';
  senderEmail: string = '';
  subject: string = '';
  scheduledDateTime: string = '';
  emailBody: string = '';
  attachments: any;
  previewOnlyBody: boolean = false;

  ngOnInit(): void {
    // Get data from query parameters
    this._route.queryParams.subscribe(params => {
      this.campaignName = params['campaignName'] || '';
      this.recipientName = params['recipientName'] || '';
      this.senderName = params['senderName'] || '';
      this.senderEmail = params['senderEmail'] || '';
      this.subject = params['subject'] || '';
      this.scheduledDateTime = params['scheduledDateTime'] || '';
      this.emailBody = params['emailBody'] || '';
      this.attachments = params['attachments'] || '';
    });

    // Alternative: Get data from window opener (if passed directly)
    if (window.opener && (window.opener as any).emailPreviewData) {
      const data = (window.opener as any).emailPreviewData;
      this.campaignName = data.campaignName || '';
      this.recipientName = data.recipientName || '';
      this.senderName = data.senderName || '';
      this.senderEmail = data.senderEmail || '';
      this.subject = data.subject || '';
      this.scheduledDateTime = data.scheduledDateTime || '';
      this.emailBody = data.emailBody || '';
      this.attachments = data.attachments || [];
      this.previewOnlyBody = !!data.previewOnlyBody;
    }
  }

  ngAfterViewInit(): void {
    this.updateIframePreview(this.emailBody);
  }

  /**
   * Print the email preview
   */
  printEmail(): void {
    window.print();
  }

  /**
   * Close the preview window
   */
  closeWindow(): void {
    window.close();
  }

  updateIframePreview(htmlSource: any) {
    if (this.previewFrame && this.previewFrame.nativeElement) {
      const iframe = this.previewFrame.nativeElement;
      const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
      
      if (iframeDoc) {
        iframeDoc.open();
        iframeDoc.write(htmlSource);
        iframeDoc.close();
      }
    }
  }
}
